import { render, staticRenderFns } from "./addManualPayment.vue?vue&type=template&id=753453bf"
import script from "./addManualPayment.vue?vue&type=script&lang=js"
export * from "./addManualPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports